import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../Firebase";

export default function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackPageView({
      path: location.pathname,
      title: document.title,
      location: window.location.href,
    });
  }, [location]);
}
